import React, { useEffect, memo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import * as R from 'ramda';
import { fetchLayerConfig } from '@actions/layers-actions';
import Layers from './layers';

const LayerList = ({publicMap}) => {
  const dispatch = useDispatch();
  const layers = useSelector(state => state?.layers);
  const { dataType } = useParams();

  useEffect(() => {
    // Fetch data on load.
    if (R.isEmpty(layers)) {
      dispatch(fetchLayerConfig());
    }
  }, [dispatch]);  // eslint-disable-line react-hooks/exhaustive-deps
                   // Don't put layers in the dependency array, so they are only loaded once
                   // (some cities might not have layers, which would trigger an endless layer fetch otherwise).

  return Object.keys(layers).map(name => {
    if (layers[name].editDisplay && (
      layers[name].editDisplay === true || 
      layers[name].editDisplay === 'public' && publicMap ||
      layers[name].editDisplay === 'internal' && !publicMap
    ) && (
      !Object.prototype.hasOwnProperty.call(layers[name].ui_style, 'editMapEntityTypes') ||
      layers[name].ui_style.editMapEntityTypes.indexOf(dataType) > -1
    )) {
      return <Layers key={`layer-${name}`} {...layers[name]} publicMap />;
    }
    return null;
  });
};

export default memo(LayerList);
